<script setup lang="ts">
interface IProps {
  label: string;
}

const model = defineModel<boolean>();
const props = defineProps<IProps>();
</script>

<template>
  <div class="flex items-center gap-2">
    <span>{{ props.label }}</span>
    <InputSwitch v-model="model" />
  </div>
</template>
